module.exports = __webpack_public_path__ + "img/preview_doc.4a9552f8.png";